module.exports = __webpack_public_path__ + "static/media/hollow_bar_postlapAERO_hand_tall.e4ad1c5f.svg";